(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-collection-refinements"] && !Shopify.designMode) return;
  try {
    function setupRefinements(scope = document) {
  scope.querySelectorAll('.ms-collection-page').forEach(page => {
    const form = page.querySelector('.ms-filter-form');
    const toggle = page.querySelector('.ms-filter-toggle');
    const trigger = page.querySelector('.ms-filter-float');
    const panel = page.querySelector('.ms-filter-drawer');
    if (!form || form.dataset.refinementsReady) return;
    form.dataset.refinementsReady = 'true';
    form.querySelector('.ms-refinements').hidden = false;
    const sync = () => {
      panel.inert = !toggle.checked;
      trigger.setAttribute('aria-expanded', String(toggle.checked));
    };
    sync();
    toggle.addEventListener('change', () => { sync(); if (toggle.checked) panel.querySelector('[data-filter-close]').focus(); });
    trigger.addEventListener('click', () => { toggle.checked = !toggle.checked; toggle.dispatchEvent(new Event('change')); });
    const close = () => { toggle.checked = false; sync(); trigger.focus(); };
    panel.querySelector('[data-filter-close]').addEventListener('click', close);
    panel.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
    form.addEventListener('submit', event => {
      event.preventDefault();
      const data = new FormData(form);
      const base = data.get('ms_category') || form.dataset.collectionBase;
      const tags = data.getAll('ms_tag');
      const material = data.get('ms_material');
      if (material) tags.push(material);
      const url = new URL(base + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : ''), window.location.origin);
      for (const [key, value] of data) if (!key.startsWith('ms_') && value !== '') url.searchParams.append(key, value);
      const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      window.location.assign(url);
    });
  });
}
setupRefinements();
document.addEventListener('shopify:section:load', event => setupRefinements(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.querySelector('[data-wishlist]');
  if (!dialog) return;
  const key = 'mutescene:wishlist:v1';
  const status = document.querySelector('.ms-wishlist-status');
  const list = dialog.querySelector('.ms-wishlist-items');
  let items = [];
  let timer;
  const safeImage = value => {
    try {
      if (typeof value !== 'string' || !value) return '';
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.myshopify.com')) ? url.href : '';
    } catch { return ''; }
  };
  const clean = value => {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.filter(p => {
      if (!p || typeof p.id !== 'string' || !/^\d+$/.test(p.id) || seen.has(p.id) || typeof p.title !== 'string' || typeof p.url !== 'string' || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(p.url)) return false;
      seen.add(p.id); return true;
    }).map(p => ({id:p.id,title:p.title,url:p.url,image:safeImage(p.image)}));
  };
  function read() { try { items = clean(JSON.parse(localStorage.getItem(key) || '[]')); } catch { items = []; } }
  function announce(message) { clearTimeout(timer); status.textContent = message; timer = setTimeout(() => { status.textContent = ''; }, 4000); }
  function sync() {
    document.querySelectorAll('[data-wish-toggle]').forEach(button => {
      const saved = items.some(p => p.id === button.dataset.id);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? dialog.dataset.remove : dialog.dataset.add} — ${button.dataset.title}`);
    });
    document.querySelectorAll('[data-wish-count]').forEach(el => { el.textContent = items.length ? String(items.length) : ''; });
  }
  function render() {
    list.replaceChildren();
    dialog.querySelector('.ms-wishlist-empty').hidden = items.length > 0;
    items.forEach(p => {
      const li = document.createElement('li');
      const a = document.createElement('a'); a.href = p.url;
      if (p.image) { const img = document.createElement('img'); img.src = p.image; img.alt = ''; img.loading = 'lazy'; img.width = 90; img.height = 90; a.append(img); }
      const title = document.createElement('span'); title.textContent = p.title; a.append(title);
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.wishRemove = p.id; remove.textContent = dialog.dataset.remove; remove.setAttribute('aria-label', `${dialog.dataset.remove} — ${p.title}`);
      li.append(a, remove); list.append(li);
    });
  }
  function save(next, message) {
    try { localStorage.setItem(key, JSON.stringify(next)); } catch { announce(dialog.dataset.error); return false; }
    items = next; sync(); if (dialog.open) render(); announce(message); return true;
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-wish-toggle]');
    if (toggle) {
      event.preventDefault(); read();
      const exists = items.some(p => p.id === toggle.dataset.id);
      const product = {id:toggle.dataset.id,title:toggle.dataset.title,url:toggle.dataset.url,image:toggle.dataset.image};
      save(exists ? items.filter(p => p.id !== product.id) : clean([...items,product]), exists ? dialog.dataset.removed : dialog.dataset.saved);
      return;
    }
    if (event.target.closest('[data-wish-open]')) { event.preventDefault(); read(); sync(); render(); if (!dialog.open) dialog.showModal(); return; }
    if (event.target.closest('[data-wish-close]')) { dialog.close(); return; }
    const remove = event.target.closest('[data-wish-remove]');
    if (remove) {
      const index = Array.from(list.querySelectorAll('button')).indexOf(remove);
      read();
      if (save(items.filter(p => p.id !== remove.dataset.wishRemove),dialog.dataset.removed)) {
        const buttons = list.querySelectorAll('button'); (buttons[Math.min(index,buttons.length-1)] || dialog.querySelector('[data-wish-close]')).focus();
      }
    }
  });
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); sync(); if(dialog.open) render(); } });
  document.addEventListener('shopify:section:load',sync);
  read(); sync(); document.documentElement.classList.add('ms-wish-ready');
})();
  } catch(e) { console.error(e); }
})();

})();
